import { jsx as a, jsxs as b, Fragment as Y } from "react/jsx-runtime";
import ae, { forwardRef as f, createElement as ne, useId as le, useState as K, useRef as pe, useEffect as xe, useCallback as F, createContext as ye, useContext as ve } from "react";
function we(e) {
  var r, t, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (r = 0; r < n; r++) e[r] && (t = we(e[r])) && (o && (o += " "), o += t);
  } else for (t in e) e[t] && (o && (o += " "), o += t);
  return o;
}
function Ge() {
  for (var e, r, t = 0, o = "", n = arguments.length; t < n; t++) (e = arguments[t]) && (r = we(e)) && (o && (o += " "), o += r);
  return o;
}
const ie = "-", Be = (e) => {
  const r = We(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (l) => {
      const i = l.split(ie);
      return i[0] === "" && i.length !== 1 && i.shift(), ke(i, r) || Ve(l);
    },
    getConflictingClassGroupIds: (l, i) => {
      const c = t[l] || [];
      return i && o[l] ? [...c, ...o[l]] : c;
    }
  };
}, ke = (e, r) => {
  var l;
  if (e.length === 0)
    return r.classGroupId;
  const t = e[0], o = r.nextPart.get(t), n = o ? ke(e.slice(1), o) : void 0;
  if (n)
    return n;
  if (r.validators.length === 0)
    return;
  const s = e.join(ie);
  return (l = r.validators.find(({
    validator: i
  }) => i(s))) == null ? void 0 : l.classGroupId;
}, me = /^\[(.+)\]$/, Ve = (e) => {
  if (me.test(e)) {
    const r = me.exec(e)[1], t = r == null ? void 0 : r.substring(0, r.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}, We = (e) => {
  const {
    theme: r,
    prefix: t
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Oe(Object.entries(e.classGroups), t).forEach(([s, l]) => {
    se(l, o, s, r);
  }), o;
}, se = (e, r, t, o) => {
  e.forEach((n) => {
    if (typeof n == "string") {
      const s = n === "" ? r : ge(r, n);
      s.classGroupId = t;
      return;
    }
    if (typeof n == "function") {
      if (Fe(n)) {
        se(n(o), r, t, o);
        return;
      }
      r.validators.push({
        validator: n,
        classGroupId: t
      });
      return;
    }
    Object.entries(n).forEach(([s, l]) => {
      se(l, ge(r, s), t, o);
    });
  });
}, ge = (e, r) => {
  let t = e;
  return r.split(ie).forEach((o) => {
    t.nextPart.has(o) || t.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(o);
  }), t;
}, Fe = (e) => e.isThemeGetter, Oe = (e, r) => r ? e.map(([t, o]) => {
  const n = o.map((s) => typeof s == "string" ? r + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([l, i]) => [r + l, i])) : s);
  return [t, n];
}) : e, qe = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let r = 0, t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  const n = (s, l) => {
    t.set(s, l), r++, r > e && (r = 0, o = t, t = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let l = t.get(s);
      if (l !== void 0)
        return l;
      if ((l = o.get(s)) !== void 0)
        return n(s, l), l;
    },
    set(s, l) {
      t.has(s) ? t.set(s, l) : n(s, l);
    }
  };
}, Ne = "!", Ue = (e) => {
  const {
    separator: r,
    experimentalParseClassName: t
  } = e, o = r.length === 1, n = r[0], s = r.length, l = (i) => {
    const c = [];
    let u = 0, p = 0, h;
    for (let x = 0; x < i.length; x++) {
      let y = i[x];
      if (u === 0) {
        if (y === n && (o || i.slice(x, x + s) === r)) {
          c.push(i.slice(p, x)), p = x + s;
          continue;
        }
        if (y === "/") {
          h = x;
          continue;
        }
      }
      y === "[" ? u++ : y === "]" && u--;
    }
    const m = c.length === 0 ? i : i.substring(p), k = m.startsWith(Ne), N = k ? m.substring(1) : m, v = h && h > p ? h - p : void 0;
    return {
      modifiers: c,
      hasImportantModifier: k,
      baseClassName: N,
      maybePostfixModifierPosition: v
    };
  };
  return t ? (i) => t({
    className: i,
    parseClassName: l
  }) : l;
}, He = (e) => {
  if (e.length <= 1)
    return e;
  const r = [];
  let t = [];
  return e.forEach((o) => {
    o[0] === "[" ? (r.push(...t.sort(), o), t = []) : t.push(o);
  }), r.push(...t.sort()), r;
}, _e = (e) => ({
  cache: qe(e.cacheSize),
  parseClassName: Ue(e),
  ...Be(e)
}), De = /\s+/, Ze = (e, r) => {
  const {
    parseClassName: t,
    getClassGroupId: o,
    getConflictingClassGroupIds: n
  } = r, s = [], l = e.trim().split(De);
  let i = "";
  for (let c = l.length - 1; c >= 0; c -= 1) {
    const u = l[c], {
      modifiers: p,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: k
    } = t(u);
    let N = !!k, v = o(N ? m.substring(0, k) : m);
    if (!v) {
      if (!N) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      if (v = o(m), !v) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      N = !1;
    }
    const x = He(p).join(":"), y = h ? x + Ne : x, S = y + v;
    if (s.includes(S))
      continue;
    s.push(S);
    const j = n(v, N);
    for (let A = 0; A < j.length; ++A) {
      const R = j[A];
      s.push(y + R);
    }
    i = u + (i.length > 0 ? " " + i : i);
  }
  return i;
};
function Ke() {
  let e = 0, r, t, o = "";
  for (; e < arguments.length; )
    (r = arguments[e++]) && (t = Ce(r)) && (o && (o += " "), o += t);
  return o;
}
const Ce = (e) => {
  if (typeof e == "string")
    return e;
  let r, t = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (r = Ce(e[o])) && (t && (t += " "), t += r);
  return t;
};
function Xe(e, ...r) {
  let t, o, n, s = l;
  function l(c) {
    const u = r.reduce((p, h) => h(p), e());
    return t = _e(u), o = t.cache.get, n = t.cache.set, s = i, i(c);
  }
  function i(c) {
    const u = o(c);
    if (u)
      return u;
    const p = Ze(c, t);
    return n(c, p), p;
  }
  return function() {
    return s(Ke.apply(null, arguments));
  };
}
const T = (e) => {
  const r = (t) => t[e] || [];
  return r.isThemeGetter = !0, r;
}, Te = /^\[(?:([a-z-]+):)?(.+)\]$/i, Je = /^\d+\/\d+$/, Qe = /* @__PURE__ */ new Set(["px", "full", "screen"]), Ye = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, er = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, rr = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, tr = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, or = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, $ = (e) => U(e) || Qe.has(e) || Je.test(e), G = (e) => H(e, "length", ur), U = (e) => !!e && !Number.isNaN(Number(e)), te = (e) => H(e, "number", U), D = (e) => !!e && Number.isInteger(Number(e)), ar = (e) => e.endsWith("%") && U(e.slice(0, -1)), g = (e) => Te.test(e), B = (e) => Ye.test(e), nr = /* @__PURE__ */ new Set(["length", "size", "percentage"]), sr = (e) => H(e, nr, Se), lr = (e) => H(e, "position", Se), ir = /* @__PURE__ */ new Set(["image", "url"]), dr = (e) => H(e, ir, pr), cr = (e) => H(e, "", br), Z = () => !0, H = (e, r, t) => {
  const o = Te.exec(e);
  return o ? o[1] ? typeof r == "string" ? o[1] === r : r.has(o[1]) : t(o[2]) : !1;
}, ur = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  er.test(e) && !rr.test(e)
), Se = () => !1, br = (e) => tr.test(e), pr = (e) => or.test(e), mr = () => {
  const e = T("colors"), r = T("spacing"), t = T("blur"), o = T("brightness"), n = T("borderColor"), s = T("borderRadius"), l = T("borderSpacing"), i = T("borderWidth"), c = T("contrast"), u = T("grayscale"), p = T("hueRotate"), h = T("invert"), m = T("gap"), k = T("gradientColorStops"), N = T("gradientColorStopPositions"), v = T("inset"), x = T("margin"), y = T("opacity"), S = T("padding"), j = T("saturate"), A = T("scale"), R = T("sepia"), I = T("skew"), O = T("space"), C = T("translate"), M = () => ["auto", "contain", "none"], P = () => ["auto", "hidden", "clip", "visible", "scroll"], V = () => ["auto", g, r], w = () => [g, r], J = () => ["", $, G], q = () => ["auto", U, g], Q = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], E = () => ["solid", "dashed", "dotted", "double", "none"], ue = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], re = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], _ = () => ["", "0", g], be = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], L = () => [U, g];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Z],
      spacing: [$, G],
      blur: ["none", "", B, g],
      brightness: L(),
      borderColor: [e],
      borderRadius: ["none", "", "full", B, g],
      borderSpacing: w(),
      borderWidth: J(),
      contrast: L(),
      grayscale: _(),
      hueRotate: L(),
      invert: _(),
      gap: w(),
      gradientColorStops: [e],
      gradientColorStopPositions: [ar, G],
      inset: V(),
      margin: V(),
      opacity: L(),
      padding: w(),
      saturate: L(),
      scale: L(),
      sepia: _(),
      skew: L(),
      space: w(),
      translate: w()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", g]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [B]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": be()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": be()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Q(), g]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: P()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": P()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": P()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", D, g]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: V()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", g]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: _()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: _()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", D, g]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Z]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", D, g]
        }, g]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": q()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": q()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Z]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [D, g]
        }, g]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": q()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": q()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", g]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", g]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [m]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [m]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [m]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...re()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...re(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...re(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [S]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [S]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [S]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [S]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [S]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [S]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [S]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [S]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [S]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [x]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [x]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [x]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [x]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [x]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [x]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [x]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [x]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [x]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [O]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [O]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", g, r]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [g, r, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [g, r, "none", "full", "min", "max", "fit", "prose", {
          screen: [B]
        }, B]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [g, r, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [g, r, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [g, r, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [g, r, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", B, G]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", te]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Z]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", g]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", U, te]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", $, g]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", g]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", g]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...E(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", $, G]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", $, g]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: w()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", g]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", g]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Q(), lr]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", sr]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, dr]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [N]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [N]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [N]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [k]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [k]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [k]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...E(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: E()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [n]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [n]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [n]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [n]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [n]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [n]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [n]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [n]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [n]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [n]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...E()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [$, g]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [$, G]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: J()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [$, G]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", B, cr]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Z]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ue(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ue()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", B, g]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [p]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [h]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [j]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [R]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [p]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [h]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [j]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [R]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [l]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [l]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [l]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", g]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: L()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", g]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: L()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", g]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [A]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [A]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [A]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [D, g]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [C]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [C]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [I]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [I]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", g]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", g]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": w()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": w()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": w()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": w()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": w()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": w()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": w()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": w()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": w()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": w()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": w()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": w()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": w()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": w()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": w()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": w()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": w()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": w()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", g]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [$, G, te]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, gr = /* @__PURE__ */ Xe(mr);
function d(...e) {
  return gr(Ge(e));
}
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fr = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), ze = (...e) => e.filter((r, t, o) => !!r && r.trim() !== "" && o.indexOf(r) === t).join(" ").trim();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var hr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xr = f(
  ({
    color: e = "currentColor",
    size: r = 24,
    strokeWidth: t = 2,
    absoluteStrokeWidth: o,
    className: n = "",
    children: s,
    iconNode: l,
    ...i
  }, c) => ne(
    "svg",
    {
      ref: c,
      ...hr,
      width: r,
      height: r,
      stroke: e,
      strokeWidth: o ? Number(t) * 24 / Number(r) : t,
      className: ze("lucide", n),
      ...i
    },
    [
      ...l.map(([u, p]) => ne(u, p)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z = (e, r) => {
  const t = f(
    ({ className: o, ...n }, s) => ne(xr, {
      ref: s,
      iconNode: r,
      className: ze(`lucide-${fr(e)}`, o),
      ...n
    })
  );
  return t.displayName = `${e}`, t;
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yr = z("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vr = z("ArrowUpDown", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wr = z("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kr = z("Bell", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nr = z("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cr = z("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Me = z("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tr = z("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ee = z("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sr = z("CircleCheckBig", [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zr = z("EyeOff", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mr = z("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ar = z("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rr = z("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jr = z("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fe = z("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ir = z("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const de = z("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const he = z("Zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]), Pr = {
  primary: d(
    "bg-[var(--accent-primary)] text-white",
    "hover:bg-[var(--accent-hover)]",
    "active:bg-[var(--accent-hover)]",
    "focus-visible:ring-[var(--accent-primary)]"
  ),
  secondary: d(
    "bg-[var(--text)] text-[var(--background)]",
    "hover:opacity-80",
    "active:opacity-70",
    "focus-visible:ring-[var(--text)]"
  ),
  ghost: d(
    "bg-transparent text-[var(--text)]",
    "hover:bg-[var(--background-tertiary)]",
    "active:bg-[var(--border)]",
    "focus-visible:ring-[var(--text-tertiary)]"
  ),
  danger: d(
    "bg-transparent text-[var(--error)] border border-[var(--error)]",
    "hover:bg-[var(--error)] hover:text-white",
    "active:bg-[var(--error)]",
    "focus-visible:ring-[var(--error)]"
  ),
  outline: d(
    "bg-transparent text-[var(--text)] border-2 border-[var(--border)]",
    "hover:border-[var(--border-hover)]",
    "active:bg-[var(--border)]",
    "focus-visible:ring-[var(--text-tertiary)]"
  ),
  cta: d(
    "bg-emerald-500 text-black",
    "hover:bg-emerald-400",
    "active:bg-emerald-600",
    "focus-visible:ring-emerald-500"
  )
}, Er = {
  pill: "rounded-full",
  rounded: "rounded-xl"
}, Lr = {
  sm: "h-8 px-3 text-sm gap-1.5",
  md: "h-10 px-4 text-base gap-2",
  lg: "h-12 px-6 text-base gap-2"
}, X = f(
  ({
    className: e,
    variant: r = "primary",
    size: t = "md",
    shape: o = "rounded",
    loading: n = !1,
    disabled: s,
    icon: l,
    iconPosition: i = "left",
    fullWidth: c = !1,
    children: u,
    ...p
  }, h) => {
    const m = s || n;
    return /* @__PURE__ */ a(
      "button",
      {
        ref: h,
        className: d(
          // Base styles
          "inline-flex items-center justify-center",
          "font-semibold",
          "transition-all duration-150 ease-out",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          "active:scale-[0.98]",
          // Shape styles
          Er[o],
          // Variant styles
          Pr[r],
          // Size styles
          Lr[t],
          // Full width
          c && "w-full",
          e
        ),
        disabled: m,
        ...p,
        children: n ? /* @__PURE__ */ b(Y, { children: [
          /* @__PURE__ */ a(Rr, { className: "h-4 w-4 animate-spin" }),
          /* @__PURE__ */ a("span", { children: "Loading..." })
        ] }) : /* @__PURE__ */ b(Y, { children: [
          l && i === "left" && /* @__PURE__ */ a("span", { className: "shrink-0", children: l }),
          u && /* @__PURE__ */ a("span", { children: u }),
          l && i === "right" && /* @__PURE__ */ a("span", { className: "shrink-0", children: l })
        ] })
      }
    );
  }
);
X.displayName = "Button";
const $r = {
  elevated: d(
    "bg-[var(--background)]",
    "border border-[var(--border)]"
  ),
  outlined: d(
    "bg-[var(--background)]",
    "border border-[var(--border)]"
  ),
  glass: d(
    "bg-[var(--glass-bg)]",
    "backdrop-blur-xl",
    "border border-[var(--glass-border)]"
  ),
  flat: d(
    "bg-[var(--background)]",
    "border-0"
  ),
  featured: d(
    "bg-[var(--text)] text-[var(--background)]",
    "border-0"
  )
}, Gr = {
  none: "p-0",
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
  xl: "p-8"
}, Br = {
  md: "rounded-xl",
  lg: "rounded-2xl",
  xl: "rounded-2xl",
  "2xl": "rounded-3xl",
  "3xl": "rounded-[32px]"
}, Vr = f(
  ({
    className: e,
    variant: r = "elevated",
    padding: t = "none",
    radius: o = "lg",
    hoverable: n = !1,
    as: s = "div",
    children: l,
    ...i
  }, c) => /* @__PURE__ */ a(
    s,
    {
      ref: c,
      className: d(
        // Base styles
        "transition-all duration-150 ease-out",
        // Radius styles
        Br[o],
        // Variant styles
        $r[r],
        // Padding
        Gr[t],
        // Hoverable - Bold editorial style: scale + border change only
        n && "cursor-pointer hover:scale-[1.02] hover:border-[var(--border-hover)]",
        e
      ),
      ...i,
      children: l
    }
  )
);
Vr.displayName = "Card";
const Wr = f(
  ({ className: e, title: r, subtitle: t, action: o, children: n, ...s }, l) => /* @__PURE__ */ b(
    "div",
    {
      ref: l,
      className: d("flex items-start justify-between gap-4 mb-4", e),
      ...s,
      children: [
        (r || t) && /* @__PURE__ */ b("div", { className: "flex flex-col gap-1", children: [
          r && /* @__PURE__ */ a("h3", { className: "text-lg font-semibold text-[var(--text)]", children: r }),
          t && /* @__PURE__ */ a("p", { className: "text-sm text-[var(--text-tertiary)]", children: t })
        ] }),
        n,
        o && /* @__PURE__ */ a("div", { className: "shrink-0", children: o })
      ]
    }
  )
);
Wr.displayName = "CardHeader";
const Fr = f(
  ({ className: e, children: r, ...t }, o) => /* @__PURE__ */ a("div", { ref: o, className: d("", e), ...t, children: r })
);
Fr.displayName = "CardContent";
const Or = f(
  ({ className: e, children: r, ...t }, o) => /* @__PURE__ */ a(
    "div",
    {
      ref: o,
      className: d("flex items-center gap-3 mt-4 pt-4 border-t border-[var(--border)]", e),
      ...t,
      children: r
    }
  )
);
Or.displayName = "CardFooter";
const qr = {
  sm: "h-8 px-3 text-body-sm",
  md: "h-10 px-4 text-body",
  lg: "h-12 px-4 text-body"
}, oe = {
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-5 h-5"
}, Ur = f(
  ({
    className: e,
    label: r,
    hint: t,
    error: o,
    size: n = "md",
    leftIcon: s,
    rightIcon: l,
    fullWidth: i = !0,
    type: c,
    id: u,
    disabled: p,
    ...h
  }, m) => {
    const k = le(), N = u || k, [v, x] = ae.useState(!1), y = c === "password", S = y ? v ? "text" : "password" : c;
    return /* @__PURE__ */ b("div", { className: d("flex flex-col gap-xs", i && "w-full"), children: [
      r && /* @__PURE__ */ a("label", { htmlFor: N, className: "text-label text-foreground-secondary", children: r }),
      /* @__PURE__ */ b("div", { className: "relative", children: [
        s && /* @__PURE__ */ a(
          "div",
          {
            className: d(
              "absolute left-3 top-1/2 -translate-y-1/2 text-foreground-tertiary",
              oe[n]
            ),
            children: s
          }
        ),
        /* @__PURE__ */ a(
          "input",
          {
            ref: m,
            id: N,
            type: S,
            disabled: p,
            className: d(
              // Base styles
              "w-full rounded-input",
              "bg-input border border-border",
              "text-foreground placeholder:text-foreground-faint",
              "transition-all duration-fast ease-out",
              // Focus styles
              "focus:outline-none focus:border-accent focus:bg-input-focus",
              "focus:ring-2 focus:ring-accent-subtle",
              // Hover styles
              "hover:border-border-hover",
              // Disabled styles
              "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-border",
              // Error styles
              o && "border-error focus:border-error focus:ring-error/20",
              // Size styles
              qr[n],
              // Icon padding
              s && "pl-10",
              (l || y) && "pr-10",
              e
            ),
            "aria-invalid": !!o,
            "aria-describedby": o ? `${N}-error` : t ? `${N}-hint` : void 0,
            ...h
          }
        ),
        y && /* @__PURE__ */ a(
          "button",
          {
            type: "button",
            onClick: () => x(!v),
            className: d(
              "absolute right-3 top-1/2 -translate-y-1/2",
              "text-foreground-tertiary hover:text-foreground-secondary",
              "transition-colors duration-fast",
              oe[n]
            ),
            tabIndex: -1,
            children: v ? /* @__PURE__ */ a(zr, {}) : /* @__PURE__ */ a(Mr, {})
          }
        ),
        l && !y && /* @__PURE__ */ a(
          "div",
          {
            className: d(
              "absolute right-3 top-1/2 -translate-y-1/2 text-foreground-tertiary",
              oe[n]
            ),
            children: l
          }
        )
      ] }),
      t && !o && /* @__PURE__ */ a("p", { id: `${N}-hint`, className: "text-caption text-foreground-tertiary", children: t }),
      o && /* @__PURE__ */ b(
        "p",
        {
          id: `${N}-error`,
          className: "flex items-center gap-xs text-caption text-error",
          role: "alert",
          children: [
            /* @__PURE__ */ a(ee, { className: "w-3 h-3" }),
            o
          ]
        }
      )
    ] });
  }
);
Ur.displayName = "Input";
const Hr = f(
  ({ className: e, label: r, hint: t, error: o, fullWidth: n = !0, id: s, disabled: l, ...i }, c) => {
    const u = le(), p = s || u;
    return /* @__PURE__ */ b("div", { className: d("flex flex-col gap-xs", n && "w-full"), children: [
      r && /* @__PURE__ */ a("label", { htmlFor: p, className: "text-label text-foreground-secondary", children: r }),
      /* @__PURE__ */ a(
        "textarea",
        {
          ref: c,
          id: p,
          disabled: l,
          className: d(
            // Base styles
            "w-full min-h-[100px] p-md rounded-input",
            "bg-input border border-border",
            "text-body text-foreground placeholder:text-foreground-faint",
            "transition-all duration-fast ease-out",
            "resize-y",
            // Focus styles
            "focus:outline-none focus:border-accent focus:bg-input-focus",
            "focus:ring-2 focus:ring-accent-subtle",
            // Hover styles
            "hover:border-border-hover",
            // Disabled styles
            "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-border",
            // Error styles
            o && "border-error focus:border-error focus:ring-error/20",
            e
          ),
          "aria-invalid": !!o,
          "aria-describedby": o ? `${p}-error` : t ? `${p}-hint` : void 0,
          ...i
        }
      ),
      t && !o && /* @__PURE__ */ a("p", { id: `${p}-hint`, className: "text-caption text-foreground-tertiary", children: t }),
      o && /* @__PURE__ */ b(
        "p",
        {
          id: `${p}-error`,
          className: "flex items-center gap-xs text-caption text-error",
          role: "alert",
          children: [
            /* @__PURE__ */ a(ee, { className: "w-3 h-3" }),
            o
          ]
        }
      )
    ] });
  }
);
Hr.displayName = "Textarea";
const _r = {
  sm: "h-8 px-3 text-body-sm",
  md: "h-10 px-4 text-body",
  lg: "h-12 px-4 text-body"
}, Dr = f(
  ({
    options: e,
    value: r,
    onChange: t,
    placeholder: o = "Select an option",
    label: n,
    hint: s,
    error: l,
    disabled: i = !1,
    fullWidth: c = !0,
    size: u = "md",
    id: p,
    name: h,
    required: m
  }, k) => {
    const N = le(), v = p || N, [x, y] = K(!1), [S, j] = K(-1), A = pe(null), R = pe(null), I = e.find((C) => C.value === r);
    xe(() => {
      const C = (M) => {
        A.current && !A.current.contains(M.target) && y(!1);
      };
      return document.addEventListener("mousedown", C), () => document.removeEventListener("mousedown", C);
    }, []);
    const O = (C) => {
      if (!i)
        switch (C.key) {
          case "Enter":
          case " ":
            if (C.preventDefault(), x && S >= 0) {
              const M = e[S];
              M && !M.disabled && (t == null || t(M.value), y(!1));
            } else
              y(!0);
            break;
          case "ArrowDown":
            C.preventDefault(), x ? j((M) => {
              const P = M + 1;
              return P >= e.length ? 0 : P;
            }) : y(!0);
            break;
          case "ArrowUp":
            C.preventDefault(), x && j((M) => {
              const P = M - 1;
              return P < 0 ? e.length - 1 : P;
            });
            break;
          case "Escape":
            y(!1);
            break;
        }
    };
    return /* @__PURE__ */ b(
      "div",
      {
        ref: A,
        className: d("relative flex flex-col gap-xs", c && "w-full"),
        children: [
          n && /* @__PURE__ */ b("label", { htmlFor: v, className: "text-label text-foreground-secondary", children: [
            n,
            m && /* @__PURE__ */ a("span", { className: "text-error ml-1", children: "*" })
          ] }),
          /* @__PURE__ */ b(
            "button",
            {
              ref: k,
              type: "button",
              id: v,
              name: h,
              disabled: i,
              onClick: () => !i && y(!x),
              onKeyDown: O,
              "aria-haspopup": "listbox",
              "aria-expanded": x,
              "aria-labelledby": n ? v : void 0,
              className: d(
                // Base styles
                "w-full flex items-center justify-between gap-md",
                "rounded-input bg-input border border-border",
                "text-left",
                "transition-all duration-fast ease-out",
                // Focus styles
                "focus:outline-none focus:border-accent focus:bg-input-focus",
                "focus:ring-2 focus:ring-accent-subtle",
                // Hover styles
                "hover:border-border-hover",
                // Disabled styles
                "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-border",
                // Error styles
                l && "border-error focus:border-error focus:ring-error/20",
                // Size styles
                _r[u]
              ),
              children: [
                /* @__PURE__ */ a(
                  "span",
                  {
                    className: d(
                      "truncate",
                      I ? "text-foreground" : "text-foreground-faint"
                    ),
                    children: (I == null ? void 0 : I.label) || o
                  }
                ),
                /* @__PURE__ */ a(
                  Cr,
                  {
                    className: d(
                      "w-4 h-4 shrink-0 text-foreground-tertiary",
                      "transition-transform duration-fast",
                      x && "rotate-180"
                    )
                  }
                )
              ]
            }
          ),
          x && /* @__PURE__ */ a(
            "ul",
            {
              ref: R,
              role: "listbox",
              "aria-labelledby": v,
              className: d(
                "absolute z-50 w-full mt-1 py-1",
                "bg-background-secondary rounded-lg shadow-lg",
                "border border-border",
                "max-h-60 overflow-auto",
                "animate-slide-down",
                "top-full"
              ),
              children: e.map((C, M) => /* @__PURE__ */ b(
                "li",
                {
                  role: "option",
                  "aria-selected": C.value === r,
                  "aria-disabled": C.disabled,
                  className: d(
                    "flex items-center justify-between gap-md px-4 py-2",
                    "cursor-pointer",
                    "transition-colors duration-fast",
                    C.disabled && "opacity-50 cursor-not-allowed",
                    !C.disabled && "hover:bg-background-tertiary",
                    S === M && "bg-background-tertiary",
                    C.value === r && "text-accent"
                  ),
                  onClick: () => {
                    C.disabled || (t == null || t(C.value), y(!1));
                  },
                  onMouseEnter: () => j(M),
                  children: [
                    /* @__PURE__ */ a("span", { className: "truncate", children: C.label }),
                    C.value === r && /* @__PURE__ */ a(Nr, { className: "w-4 h-4 shrink-0" })
                  ]
                },
                C.value
              ))
            }
          ),
          s && !l && /* @__PURE__ */ a("p", { className: "text-caption text-foreground-tertiary", children: s }),
          l && /* @__PURE__ */ b("p", { className: "flex items-center gap-xs text-caption text-error", role: "alert", children: [
            /* @__PURE__ */ a(ee, { className: "w-3 h-3" }),
            l
          ] })
        ]
      }
    );
  }
);
Dr.displayName = "Select";
const Zr = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  full: "max-w-[calc(100vw-48px)] max-h-[calc(100vh-48px)]"
}, Ae = f(
  ({
    open: e,
    onClose: r,
    title: t,
    description: o,
    children: n,
    size: s = "md",
    showCloseButton: l = !0,
    closeOnOverlayClick: i = !0,
    closeOnEscape: c = !0,
    footer: u
  }, p) => {
    const h = F(
      (m) => {
        m.key === "Escape" && c && r();
      },
      [r, c]
    );
    return xe(() => (e && (document.addEventListener("keydown", h), document.body.style.overflow = "hidden"), () => {
      document.removeEventListener("keydown", h), document.body.style.overflow = "";
    }), [e, h]), e ? /* @__PURE__ */ b(
      "div",
      {
        ref: p,
        className: "fixed inset-0 z-50 flex items-center justify-center p-lg",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": t ? "modal-title" : void 0,
        "aria-describedby": o ? "modal-description" : void 0,
        children: [
          /* @__PURE__ */ a(
            "div",
            {
              className: d(
                "fixed inset-0 bg-black/50 backdrop-blur-sm",
                "animate-fade-in"
              ),
              onClick: i ? r : void 0,
              "aria-hidden": "true"
            }
          ),
          /* @__PURE__ */ b(
            "div",
            {
              className: d(
                "relative w-full bg-background-secondary rounded-modal shadow-xl",
                "animate-slide-up",
                "flex flex-col max-h-[calc(100vh-48px)]",
                Zr[s]
              ),
              children: [
                (t || l) && /* @__PURE__ */ b("div", { className: "flex items-start justify-between gap-lg p-xl border-b border-border", children: [
                  /* @__PURE__ */ b("div", { className: "flex flex-col gap-xs", children: [
                    t && /* @__PURE__ */ a("h2", { id: "modal-title", className: "text-h3 text-foreground", children: t }),
                    o && /* @__PURE__ */ a("p", { id: "modal-description", className: "text-body-sm text-foreground-tertiary", children: o })
                  ] }),
                  l && /* @__PURE__ */ a(
                    X,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: r,
                      className: "shrink-0 -mr-2 -mt-1",
                      "aria-label": "Close modal",
                      children: /* @__PURE__ */ a(de, { className: "w-5 h-5" })
                    }
                  )
                ] }),
                /* @__PURE__ */ a("div", { className: "flex-1 overflow-auto p-xl", children: n }),
                u && /* @__PURE__ */ a("div", { className: "flex items-center justify-end gap-md p-xl border-t border-border", children: u })
              ]
            }
          )
        ]
      }
    ) : null;
  }
);
Ae.displayName = "Modal";
const Kr = f(
  ({
    confirmText: e = "Confirm",
    cancelText: r = "Cancel",
    onConfirm: t,
    onClose: o,
    variant: n = "default",
    loading: s = !1,
    description: l,
    ...i
  }, c) => /* @__PURE__ */ a(
    Ae,
    {
      ref: c,
      onClose: o,
      size: "sm",
      description: l,
      footer: /* @__PURE__ */ b(Y, { children: [
        /* @__PURE__ */ a(X, { variant: "ghost", onClick: o, disabled: s, children: r }),
        /* @__PURE__ */ a(
          X,
          {
            variant: n === "danger" ? "danger" : "primary",
            onClick: t,
            loading: s,
            children: e
          }
        )
      ] }),
      ...i,
      children: l && /* @__PURE__ */ a("p", { className: "text-body text-foreground-secondary", children: l })
    }
  )
);
Kr.displayName = "ConfirmDialog";
const Re = ye(null);
function je() {
  const e = ve(Re);
  if (!e)
    throw new Error("Tabs components must be used within a Tabs provider");
  return e;
}
const Xr = f(
  ({ value: e, onValueChange: r, children: t, className: o, ...n }, s) => /* @__PURE__ */ a(Re.Provider, { value: { value: e, onValueChange: r }, children: /* @__PURE__ */ a("div", { ref: s, className: d("w-full", o), ...n, children: t }) })
);
Xr.displayName = "Tabs";
const Jr = {
  default: "bg-background-tertiary p-1 rounded-lg gap-1",
  pills: "gap-2",
  underline: "border-b border-border gap-0"
}, Qr = f(
  ({ className: e, variant: r = "default", children: t, ...o }, n) => /* @__PURE__ */ a(
    "div",
    {
      ref: n,
      role: "tablist",
      className: d("flex items-center", Jr[r], e),
      ...o,
      children: t
    }
  )
);
Qr.displayName = "TabsList";
const Yr = {
  default: {
    base: "px-lg py-sm rounded-md text-body-sm font-medium transition-all duration-fast",
    inactive: "text-foreground-tertiary hover:text-foreground-secondary",
    active: "bg-background-secondary text-foreground shadow-sm"
  },
  pills: {
    base: "px-lg py-sm rounded-full text-body-sm font-medium transition-all duration-fast",
    inactive: "text-foreground-tertiary hover:text-foreground-secondary hover:bg-background-tertiary",
    active: "bg-accent text-white"
  },
  underline: {
    base: "px-lg py-md text-body-sm font-medium transition-all duration-fast relative",
    inactive: "text-foreground-tertiary hover:text-foreground-secondary",
    active: "text-accent"
  }
}, et = f(
  ({ className: e, value: r, variant: t = "default", children: o, ...n }, s) => {
    const { value: l, onValueChange: i } = je(), c = l === r, u = Yr[t];
    return /* @__PURE__ */ b(
      "button",
      {
        ref: s,
        role: "tab",
        type: "button",
        "aria-selected": c,
        "data-state": c ? "active" : "inactive",
        className: d(u.base, c ? u.active : u.inactive, e),
        onClick: () => i(r),
        ...n,
        children: [
          o,
          t === "underline" && c && /* @__PURE__ */ a("span", { className: "absolute bottom-0 left-0 right-0 h-0.5 bg-accent" })
        ]
      }
    );
  }
);
et.displayName = "TabsTrigger";
const rt = f(
  ({ className: e, value: r, children: t, ...o }, n) => {
    const { value: s } = je();
    return s !== r ? null : /* @__PURE__ */ a(
      "div",
      {
        ref: n,
        role: "tabpanel",
        "data-state": s === r ? "active" : "inactive",
        className: d("mt-lg animate-fade-in", e),
        ...o,
        children: t
      }
    );
  }
);
rt.displayName = "TabsContent";
const tt = {
  default: "bg-background-tertiary text-foreground-secondary",
  accent: "bg-accent-subtle text-accent",
  success: "bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400",
  warning: "bg-yellow-50 text-yellow-700 dark:bg-yellow-900/20 dark:text-yellow-400",
  error: "bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400",
  info: "bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400",
  gold: "bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400",
  outline: "bg-transparent border border-border text-foreground-secondary"
}, ot = {
  sm: "px-1.5 py-0.5 text-[10px]",
  md: "px-2 py-1 text-caption"
}, at = {
  default: "bg-foreground-tertiary",
  accent: "bg-accent",
  success: "bg-green-500",
  warning: "bg-yellow-500",
  error: "bg-red-500",
  info: "bg-blue-500",
  gold: "bg-amber-500",
  outline: "bg-foreground-tertiary"
}, ce = f(
  ({ className: e, variant: r = "default", size: t = "md", icon: o, dot: n, children: s, ...l }, i) => /* @__PURE__ */ b(
    "span",
    {
      ref: i,
      className: d(
        // Base styles
        "inline-flex items-center gap-1 font-medium rounded-full",
        "whitespace-nowrap",
        // Variant styles
        tt[r],
        // Size styles
        ot[t],
        e
      ),
      ...l,
      children: [
        n && /* @__PURE__ */ a("span", { className: d("w-1.5 h-1.5 rounded-full shrink-0", at[r]) }),
        o && /* @__PURE__ */ a("span", { className: "shrink-0 w-3 h-3", children: o }),
        s
      ]
    }
  )
);
ce.displayName = "Badge";
const nt = {
  weight: { variant: "gold", label: "Weight PR" },
  reps: { variant: "default", label: "Reps PR" },
  volume: { variant: "default", label: "Volume PR" },
  "1rm": { variant: "default", label: "1RM PR" }
}, st = f(
  ({ prType: e = "weight", children: r, ...t }, o) => {
    const n = nt[e];
    return /* @__PURE__ */ a(ce, { ref: o, variant: n.variant, ...t, children: r ?? n.label });
  }
);
st.displayName = "PRBadge";
const lt = f(
  ({ tier: e, children: r, ...t }, o) => {
    const n = {
      free: { variant: "default", label: "Free" },
      power_rack: { variant: "accent", label: "Power Rack" },
      trial: { variant: "info", label: "Trial" }
    }, { variant: s, label: l } = n[e];
    return /* @__PURE__ */ a(ce, { ref: o, variant: s, ...t, children: r || l });
  }
);
lt.displayName = "TierBadge";
const W = f(
  ({
    className: e,
    variant: r = "rectangular",
    width: t,
    height: o,
    animation: n = "pulse",
    style: s,
    ...l
  }, i) => {
    const c = {
      text: "rounded h-4",
      circular: "rounded-full",
      rectangular: "rounded-card"
    }, u = {
      pulse: "animate-pulse",
      wave: "skeleton-wave",
      none: ""
    };
    return /* @__PURE__ */ a(
      "div",
      {
        ref: i,
        className: d(
          "bg-background-tertiary",
          c[r],
          u[n],
          e
        ),
        style: {
          width: t,
          height: o,
          ...s
        },
        "aria-hidden": "true",
        ...l
      }
    );
  }
);
W.displayName = "Skeleton";
const Ie = f(
  ({ className: e, lines: r = 3, lastLineWidth: t = "60%", ...o }, n) => /* @__PURE__ */ a("div", { ref: n, className: d("flex flex-col gap-sm", e), ...o, children: Array.from({ length: r }).map((s, l) => /* @__PURE__ */ a(
    W,
    {
      variant: "text",
      style: {
        width: l === r - 1 ? t : "100%"
      }
    },
    l
  )) })
);
Ie.displayName = "SkeletonText";
const it = f(
  ({ className: e, hasHeader: r = !0, hasImage: t = !1, lines: o = 2, ...n }, s) => /* @__PURE__ */ b(
    "div",
    {
      ref: s,
      className: d(
        "bg-background-secondary rounded-card p-lg shadow-card",
        e
      ),
      ...n,
      children: [
        t && /* @__PURE__ */ a(W, { className: "w-full h-40 mb-lg" }),
        r && /* @__PURE__ */ b("div", { className: "flex items-center gap-md mb-lg", children: [
          /* @__PURE__ */ a(W, { variant: "circular", width: 40, height: 40 }),
          /* @__PURE__ */ b("div", { className: "flex-1", children: [
            /* @__PURE__ */ a(W, { variant: "text", width: "50%", className: "mb-sm" }),
            /* @__PURE__ */ a(W, { variant: "text", width: "30%" })
          ] })
        ] }),
        /* @__PURE__ */ a(Ie, { lines: o })
      ]
    }
  )
);
it.displayName = "SkeletonCard";
const dt = f(
  ({ className: e, columns: r = 4, ...t }, o) => /* @__PURE__ */ a(
    "div",
    {
      ref: o,
      className: d("flex items-center gap-lg py-md border-b border-border", e),
      ...t,
      children: Array.from({ length: r }).map((n, s) => /* @__PURE__ */ a(
        W,
        {
          variant: "text",
          className: "flex-1",
          style: { width: s === 0 ? "30%" : "20%" }
        },
        s
      ))
    }
  )
);
dt.displayName = "SkeletonTableRow";
const Pe = ye(null);
function ct() {
  const e = ve(Pe);
  if (!e)
    throw new Error("useToast must be used within a ToastProvider");
  return e;
}
function St() {
  const { addToast: e } = ct();
  return {
    success: (r, t) => e({ type: "success", title: r, description: t }),
    error: (r, t) => e({ type: "error", title: r, description: t }),
    warning: (r, t) => e({ type: "warning", title: r, description: t }),
    info: (r, t) => e({ type: "info", title: r, description: t })
  };
}
function zt({
  children: e,
  position: r = "bottom-right",
  maxToasts: t = 5
}) {
  const [o, n] = K([]), s = F(
    (u) => {
      const p = Math.random().toString(36).substring(2, 9), h = {
        ...u,
        id: p,
        duration: u.duration ?? 5e3
      };
      return n((m) => [h, ...m].slice(0, t)), h.duration && h.duration > 0 && setTimeout(() => {
        n((m) => m.filter((k) => k.id !== p));
      }, h.duration), p;
    },
    [t]
  ), l = F((u) => {
    n((p) => p.filter((h) => h.id !== u));
  }, []), i = F(() => {
    n([]);
  }, []), c = {
    "top-right": "top-xl right-xl",
    "top-left": "top-xl left-xl",
    "bottom-right": "bottom-xl right-xl",
    "bottom-left": "bottom-xl left-xl",
    "top-center": "top-xl left-1/2 -translate-x-1/2",
    "bottom-center": "bottom-xl left-1/2 -translate-x-1/2"
  };
  return /* @__PURE__ */ b(Pe.Provider, { value: { toasts: o, addToast: s, removeToast: l, clearToasts: i }, children: [
    e,
    /* @__PURE__ */ a(
      "div",
      {
        className: d(
          "fixed z-[100] flex flex-col gap-sm pointer-events-none",
          c[r]
        ),
        "aria-live": "polite",
        "aria-label": "Notifications",
        children: o.map((u) => /* @__PURE__ */ a(Ee, { toast: u, onDismiss: () => l(u.id) }, u.id))
      }
    )
  ] });
}
const ut = {
  success: /* @__PURE__ */ a(Sr, { className: "w-5 h-5 text-green-500" }),
  error: /* @__PURE__ */ a(ee, { className: "w-5 h-5 text-red-500" }),
  warning: /* @__PURE__ */ a(Ir, { className: "w-5 h-5 text-yellow-500" }),
  info: /* @__PURE__ */ a(Ar, { className: "w-5 h-5 text-blue-500" })
}, bt = {
  success: "border-l-green-500",
  error: "border-l-red-500",
  warning: "border-l-yellow-500",
  info: "border-l-blue-500"
}, Ee = f(({ toast: e, onDismiss: r }, t) => /* @__PURE__ */ a(
  "div",
  {
    ref: t,
    className: d(
      "pointer-events-auto",
      "w-80 bg-background-secondary rounded-lg shadow-lg",
      "border border-border border-l-4",
      "p-lg",
      "animate-slide-up",
      bt[e.type]
    ),
    role: "alert",
    children: /* @__PURE__ */ b("div", { className: "flex items-start gap-md", children: [
      /* @__PURE__ */ a("div", { className: "shrink-0", children: ut[e.type] }),
      /* @__PURE__ */ b("div", { className: "flex-1 min-w-0", children: [
        /* @__PURE__ */ a("p", { className: "text-body-sm font-medium text-foreground", children: e.title }),
        e.description && /* @__PURE__ */ a("p", { className: "mt-xs text-caption text-foreground-tertiary", children: e.description })
      ] }),
      /* @__PURE__ */ a(
        "button",
        {
          onClick: r,
          className: d(
            "shrink-0 p-1 rounded",
            "text-foreground-tertiary hover:text-foreground-secondary",
            "hover:bg-background-tertiary",
            "transition-colors duration-fast"
          ),
          "aria-label": "Dismiss notification",
          children: /* @__PURE__ */ a(de, { className: "w-4 h-4" })
        }
      )
    ] })
  }
));
Ee.displayName = "ToastItem";
const pt = f(
  ({ className: e, children: r, ...t }, o) => /* @__PURE__ */ a("div", { className: "w-full overflow-auto", children: /* @__PURE__ */ a(
    "table",
    {
      ref: o,
      className: d("w-full caption-bottom text-body", e),
      ...t,
      children: r
    }
  ) })
);
pt.displayName = "Table";
const mt = f(
  ({ className: e, children: r, ...t }, o) => /* @__PURE__ */ a("thead", { ref: o, className: d("border-b border-border", e), ...t, children: r })
);
mt.displayName = "TableHeader";
const gt = f(
  ({ className: e, children: r, ...t }, o) => /* @__PURE__ */ a("tbody", { ref: o, className: d("[&_tr:last-child]:border-0", e), ...t, children: r })
);
gt.displayName = "TableBody";
const ft = f(
  ({ className: e, children: r, ...t }, o) => /* @__PURE__ */ a(
    "tfoot",
    {
      ref: o,
      className: d("border-t border-border bg-background-tertiary font-medium", e),
      ...t,
      children: r
    }
  )
);
ft.displayName = "TableFooter";
const ht = f(
  ({ className: e, hoverable: r = !0, selected: t = !1, children: o, ...n }, s) => /* @__PURE__ */ a(
    "tr",
    {
      ref: s,
      className: d(
        "border-b border-border transition-colors duration-fast",
        r && "hover:bg-background-tertiary/50",
        t && "bg-accent-subtle",
        e
      ),
      ...n,
      children: o
    }
  )
);
ht.displayName = "TableRow";
const xt = f(
  ({ className: e, sortable: r = !1, sortDirection: t, onSort: o, children: n, ...s }, l) => {
    const i = t === "asc" ? wr : t === "desc" ? yr : vr;
    return /* @__PURE__ */ a(
      "th",
      {
        ref: l,
        className: d(
          "h-12 px-lg text-left align-middle text-body-sm font-semibold text-foreground-secondary",
          r && "cursor-pointer select-none hover:text-foreground",
          e
        ),
        onClick: r ? o : void 0,
        ...s,
        children: /* @__PURE__ */ b("div", { className: "flex items-center gap-xs", children: [
          n,
          r && /* @__PURE__ */ a(
            i,
            {
              className: d(
                "w-4 h-4",
                t ? "text-accent" : "text-foreground-faint"
              )
            }
          )
        ] })
      }
    );
  }
);
xt.displayName = "TableHead";
const yt = f(
  ({ className: e, children: r, ...t }, o) => /* @__PURE__ */ a(
    "td",
    {
      ref: o,
      className: d("p-lg align-middle text-foreground", e),
      ...t,
      children: r
    }
  )
);
yt.displayName = "TableCell";
const vt = f(
  ({ className: e, children: r, ...t }, o) => /* @__PURE__ */ a(
    "caption",
    {
      ref: o,
      className: d("mt-lg text-body-sm text-foreground-tertiary", e),
      ...t,
      children: r
    }
  )
);
vt.displayName = "TableCaption";
const wt = f(
  ({ colSpan: e, message: r = "No data available", action: t, className: o, ...n }, s) => /* @__PURE__ */ a("tr", { ref: s, className: o, ...n, children: /* @__PURE__ */ a("td", { colSpan: e, className: "p-xl text-center", children: /* @__PURE__ */ b("div", { className: "flex flex-col items-center gap-md", children: [
    /* @__PURE__ */ a("p", { className: "text-body text-foreground-tertiary", children: r }),
    t
  ] }) }) })
);
wt.displayName = "TableEmpty";
const Le = f(
  ({
    className: e,
    items: r,
    currentPath: t,
    onNavigate: o,
    collapsed: n = !1,
    onToggleCollapse: s,
    logo: l,
    footer: i,
    showUpgrade: c = !1,
    onUpgradeClick: u,
    ...p
  }, h) => /* @__PURE__ */ b(
    "aside",
    {
      ref: h,
      className: d(
        "flex flex-col h-full bg-[var(--background)] border-r border-[var(--border)]",
        "transition-all duration-300 ease-out",
        n ? "w-[72px]" : "w-[240px]",
        e
      ),
      ...p,
      children: [
        /* @__PURE__ */ b(
          "div",
          {
            className: d(
              "flex items-center h-16 px-6 border-b border-[var(--border)]",
              n ? "justify-center" : "justify-between"
            ),
            children: [
              l && /* @__PURE__ */ a("div", { className: d("flex items-center gap-2", n && "justify-center"), children: l }),
              s && /* @__PURE__ */ a(
                "button",
                {
                  onClick: s,
                  className: d(
                    "p-1.5 rounded-md",
                    "text-[var(--text-tertiary)] hover:text-[var(--text)]",
                    "hover:bg-[var(--background-tertiary)]",
                    "transition-colors duration-150",
                    n && "absolute right-0 translate-x-1/2 bg-[var(--background)] border border-[var(--border)]"
                  ),
                  "aria-label": n ? "Expand sidebar" : "Collapse sidebar",
                  children: n ? /* @__PURE__ */ a(Tr, { className: "w-4 h-4" }) : /* @__PURE__ */ a(Me, { className: "w-4 h-4" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a("nav", { className: "flex-1 py-4 px-2 overflow-y-auto", children: /* @__PURE__ */ a("ul", { className: "flex flex-col gap-1", children: r.map((m) => {
          const k = t === m.path || t.startsWith(m.path + "/");
          return /* @__PURE__ */ a("li", { children: /* @__PURE__ */ b(
            "button",
            {
              onClick: () => o(m.path),
              className: d(
                "w-full flex items-center gap-3 px-3 py-2.5 rounded-xl",
                "text-sm font-medium tracking-tight",
                "transition-all duration-150 ease-out",
                n ? "justify-center" : "justify-start",
                k ? "bg-[var(--text)] text-[var(--background)]" : "text-[var(--text-secondary)] hover:bg-[var(--background-tertiary)] hover:text-[var(--text)]"
              ),
              title: n ? m.label : void 0,
              children: [
                /* @__PURE__ */ a("span", { className: "shrink-0 w-5 h-5", children: m.icon }),
                !n && /* @__PURE__ */ b(Y, { children: [
                  /* @__PURE__ */ a("span", { className: "flex-1 text-left truncate", children: m.label }),
                  m.badge !== void 0 && /* @__PURE__ */ a(
                    "span",
                    {
                      className: d(
                        "px-1.5 py-0.5 text-[10px] font-semibold rounded-full",
                        k ? "bg-[var(--background)]/20 text-[var(--background)]" : "bg-[var(--accent-subtle)] text-[var(--accent-primary)]"
                      ),
                      children: m.badge
                    }
                  )
                ] })
              ]
            }
          ) }, m.path);
        }) }) }),
        c && /* @__PURE__ */ a("div", { className: d("px-2 pb-4", n && "flex justify-center"), children: n ? /* @__PURE__ */ a(
          "button",
          {
            onClick: u,
            className: d(
              "p-2 rounded-xl",
              "bg-[var(--text)] text-[var(--background)]",
              "hover:opacity-80",
              "transition-opacity duration-150"
            ),
            title: "Upgrade to Power Rack",
            children: /* @__PURE__ */ a(he, { className: "w-5 h-5" })
          }
        ) : /* @__PURE__ */ b("div", { className: "p-4 rounded-2xl bg-[var(--text)] text-[var(--background)]", children: [
          /* @__PURE__ */ b("div", { className: "flex items-center gap-2 mb-2", children: [
            /* @__PURE__ */ a(he, { className: "w-5 h-5" }),
            /* @__PURE__ */ a("span", { className: "text-sm font-semibold tracking-tight", children: "Power Rack" })
          ] }),
          /* @__PURE__ */ a("p", { className: "text-xs opacity-70 mb-3", children: "Unlock all features with Power Rack subscription." }),
          /* @__PURE__ */ a(
            X,
            {
              variant: "secondary",
              size: "sm",
              fullWidth: !0,
              onClick: u,
              className: "bg-[var(--background)] text-[var(--text)] hover:opacity-80",
              children: "Upgrade"
            }
          )
        ] }) }),
        i && /* @__PURE__ */ a("div", { className: d("px-2 pb-4 border-t border-[var(--border)] pt-4", n && "px-1"), children: i })
      ]
    }
  )
);
Le.displayName = "Sidebar";
const $e = f(
  ({
    className: e,
    title: r,
    onMenuClick: t,
    showMenuButton: o = !1,
    searchValue: n = "",
    onSearchChange: s,
    onSearchSubmit: l,
    showSearch: i = !1,
    notifications: c = 0,
    onNotificationsClick: u,
    userAvatar: p,
    actions: h,
    ...m
  }, k) => {
    const [N, v] = ae.useState(n), [x, y] = ae.useState(!1), S = (R) => {
      const I = R.target.value;
      v(I), s == null || s(I);
    }, j = (R) => {
      R.preventDefault(), l == null || l(N);
    }, A = () => {
      v(""), s == null || s(""), y(!1);
    };
    return /* @__PURE__ */ b(
      "header",
      {
        ref: k,
        className: d(
          "flex items-center justify-between h-16 px-lg",
          "bg-background-secondary border-b border-border",
          "sticky top-0 z-40",
          e
        ),
        ...m,
        children: [
          /* @__PURE__ */ b("div", { className: "flex items-center gap-md", children: [
            o && /* @__PURE__ */ a(
              "button",
              {
                onClick: t,
                className: d(
                  "p-2 rounded-lg",
                  "text-foreground-secondary hover:text-foreground",
                  "hover:bg-background-tertiary",
                  "transition-colors duration-fast",
                  "lg:hidden"
                ),
                "aria-label": "Toggle menu",
                children: /* @__PURE__ */ a(jr, { className: "w-5 h-5" })
              }
            ),
            r && /* @__PURE__ */ a("h1", { className: "text-h3 font-semibold text-foreground truncate", children: r })
          ] }),
          i && /* @__PURE__ */ a(
            "div",
            {
              className: d(
                "hidden md:flex items-center flex-1 max-w-md mx-lg",
                x && "flex absolute inset-x-0 px-lg md:relative md:px-0"
              ),
              children: /* @__PURE__ */ a("form", { onSubmit: j, className: "w-full", children: /* @__PURE__ */ b("div", { className: "relative", children: [
                /* @__PURE__ */ a(fe, { className: "absolute left-md top-1/2 -translate-y-1/2 w-4 h-4 text-foreground-tertiary" }),
                /* @__PURE__ */ a(
                  "input",
                  {
                    type: "text",
                    value: N,
                    onChange: S,
                    placeholder: "Search...",
                    className: d(
                      "w-full pl-10 pr-10 py-sm",
                      "bg-background-tertiary border border-transparent",
                      "rounded-lg text-body-sm text-foreground",
                      "placeholder:text-foreground-tertiary",
                      "focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/20",
                      "transition-all duration-fast"
                    )
                  }
                ),
                N && /* @__PURE__ */ a(
                  "button",
                  {
                    type: "button",
                    onClick: A,
                    className: "absolute right-md top-1/2 -translate-y-1/2 p-0.5 rounded text-foreground-tertiary hover:text-foreground",
                    children: /* @__PURE__ */ a(de, { className: "w-4 h-4" })
                  }
                )
              ] }) })
            }
          ),
          i && !x && /* @__PURE__ */ a(
            "button",
            {
              onClick: () => y(!0),
              className: d(
                "p-2 rounded-lg md:hidden",
                "text-foreground-secondary hover:text-foreground",
                "hover:bg-background-tertiary",
                "transition-colors duration-fast"
              ),
              "aria-label": "Search",
              children: /* @__PURE__ */ a(fe, { className: "w-5 h-5" })
            }
          ),
          /* @__PURE__ */ b("div", { className: "flex items-center gap-sm", children: [
            h,
            u && /* @__PURE__ */ b(
              "button",
              {
                onClick: u,
                className: d(
                  "relative p-2 rounded-lg",
                  "text-foreground-secondary hover:text-foreground",
                  "hover:bg-background-tertiary",
                  "transition-colors duration-fast"
                ),
                "aria-label": `Notifications${c > 0 ? ` (${c} unread)` : ""}`,
                children: [
                  /* @__PURE__ */ a(kr, { className: "w-5 h-5" }),
                  c > 0 && /* @__PURE__ */ a(
                    "span",
                    {
                      className: d(
                        "absolute -top-0.5 -right-0.5",
                        "min-w-[18px] h-[18px] px-1",
                        "flex items-center justify-center",
                        "bg-error text-white",
                        "text-[10px] font-semibold rounded-full"
                      ),
                      children: c > 99 ? "99+" : c
                    }
                  )
                ]
              }
            ),
            p && /* @__PURE__ */ a("div", { className: "ml-sm", children: p })
          ] })
        ]
      }
    );
  }
);
$e.displayName = "Header";
const kt = f(
  ({
    className: e,
    title: r,
    subtitle: t,
    description: o,
    breadcrumbs: n,
    onBack: s,
    backLabel: l = "Back",
    actions: i,
    badge: c,
    tabs: u,
    ...p
  }, h) => /* @__PURE__ */ b(
    "div",
    {
      ref: h,
      className: d("space-y-4", e),
      ...p,
      children: [
        n && n.length > 0 && /* @__PURE__ */ a("nav", { "aria-label": "Breadcrumb", children: /* @__PURE__ */ a("ol", { className: "flex items-center gap-1 text-sm text-[var(--text-tertiary)]", children: n.map((m, k) => /* @__PURE__ */ b("li", { className: "flex items-center gap-1", children: [
          k > 0 && /* @__PURE__ */ a("span", { className: "text-[var(--text-tertiary)]", children: "/" }),
          m.onClick || m.href ? /* @__PURE__ */ a(
            "button",
            {
              onClick: m.onClick,
              className: "hover:text-[var(--text)] transition-colors duration-[var(--duration-fast)]",
              children: m.label
            }
          ) : /* @__PURE__ */ a("span", { className: k === n.length - 1 ? "text-[var(--text)]" : "", children: m.label })
        ] }, k)) }) }),
        s && /* @__PURE__ */ b(
          "button",
          {
            onClick: s,
            className: d(
              "inline-flex items-center gap-1",
              "text-sm text-[var(--text-secondary)]",
              "hover:text-[var(--text)]",
              "transition-colors duration-[var(--duration-fast)]"
            ),
            children: [
              /* @__PURE__ */ a(Me, { className: "w-4 h-4" }),
              /* @__PURE__ */ a("span", { children: l })
            ]
          }
        ),
        /* @__PURE__ */ b("div", { className: "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4", children: [
          /* @__PURE__ */ b("div", { className: "space-y-2", children: [
            /* @__PURE__ */ b("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ a("h1", { className: "text-3xl md:text-4xl font-bold text-[var(--text)] tracking-tight", children: r }),
              c
            ] }),
            (t || o) && /* @__PURE__ */ a("p", { className: "text-base text-[var(--text-tertiary)] max-w-2xl", children: t || o })
          ] }),
          i && /* @__PURE__ */ a("div", { className: "flex items-center gap-3 shrink-0", children: i })
        ] }),
        u && /* @__PURE__ */ a("div", { className: "border-b border-[var(--border)] -mx-6 px-6", children: u })
      ]
    }
  )
);
kt.displayName = "PageHeader";
const Nt = f(
  ({
    className: e,
    children: r,
    navItems: t,
    currentPath: o,
    onNavigate: n,
    logo: s,
    collapsedLogo: l,
    sidebarFooter: i,
    showUpgrade: c = !1,
    onUpgradeClick: u,
    headerTitle: p,
    showSearch: h = !1,
    searchValue: m,
    onSearchChange: k,
    onSearchSubmit: N,
    notifications: v,
    onNotificationsClick: x,
    userAvatar: y,
    headerActions: S,
    defaultCollapsed: j = !1,
    collapsed: A,
    onCollapsedChange: R,
    ...I
  }, O) => {
    const [C, M] = K(j), [P, V] = K(!1), w = A ?? C, J = F(() => {
      const E = !w;
      M(E), R == null || R(E);
    }, [w, R]), q = F(() => {
      V((E) => !E);
    }, []), Q = F(
      (E) => {
        n(E), V(!1);
      },
      [n]
    );
    return /* @__PURE__ */ b(
      "div",
      {
        ref: O,
        className: d("flex h-screen bg-background overflow-hidden", e),
        ...I,
        children: [
          P && /* @__PURE__ */ a(
            "div",
            {
              className: "fixed inset-0 bg-black/50 z-40 lg:hidden",
              onClick: () => V(!1),
              "aria-hidden": "true"
            }
          ),
          /* @__PURE__ */ a(
            "div",
            {
              className: d(
                "fixed inset-y-0 left-0 z-50 lg:relative lg:z-0",
                "transform transition-transform duration-normal ease-out",
                P ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
              ),
              children: /* @__PURE__ */ a(
                Le,
                {
                  items: t,
                  currentPath: o,
                  onNavigate: Q,
                  collapsed: w,
                  onToggleCollapse: J,
                  logo: w && l || s,
                  footer: i,
                  showUpgrade: c,
                  onUpgradeClick: u
                }
              )
            }
          ),
          /* @__PURE__ */ b("div", { className: "flex-1 flex flex-col min-w-0 overflow-hidden", children: [
            /* @__PURE__ */ a(
              $e,
              {
                title: p,
                onMenuClick: q,
                showMenuButton: !0,
                showSearch: h,
                searchValue: m,
                onSearchChange: k,
                onSearchSubmit: N,
                notifications: v,
                onNotificationsClick: x,
                userAvatar: y,
                actions: S
              }
            ),
            /* @__PURE__ */ a("main", { className: "flex-1 overflow-y-auto", children: /* @__PURE__ */ a("div", { className: "px-6 md:px-8 lg:px-12 py-8 md:py-10", children: /* @__PURE__ */ a("div", { className: "max-w-6xl mx-auto", children: r }) }) })
          ] })
        ]
      }
    );
  }
);
Nt.displayName = "Layout";
export {
  ce as Badge,
  X as Button,
  Vr as Card,
  Fr as CardContent,
  Or as CardFooter,
  Wr as CardHeader,
  Kr as ConfirmDialog,
  $e as Header,
  Ur as Input,
  Nt as Layout,
  Ae as Modal,
  st as PRBadge,
  kt as PageHeader,
  Dr as Select,
  Le as Sidebar,
  W as Skeleton,
  it as SkeletonCard,
  dt as SkeletonTableRow,
  Ie as SkeletonText,
  pt as Table,
  gt as TableBody,
  vt as TableCaption,
  yt as TableCell,
  wt as TableEmpty,
  ft as TableFooter,
  xt as TableHead,
  mt as TableHeader,
  ht as TableRow,
  Xr as Tabs,
  rt as TabsContent,
  Qr as TabsList,
  et as TabsTrigger,
  Hr as Textarea,
  lt as TierBadge,
  zt as ToastProvider,
  d as cn,
  ct as useToast,
  St as useToastActions
};
